import snakeCase from "voca/snake_case";
import titleCase from "voca/title_case";
/**
 * Maps snake_case props to Proper Case human-friendly properties. Props that are `undefined` or `null` are omitted and `boolean` values are converted to `Yes | No`.
 *
 * @param props Event properties with snake_case keys
 * @return Event properties with Proper Case keys and mapped human-friendly values
 * @hidden
 */
export const buildHeapProperties = (props) => {
    const properties = {};
    /* istanbul ignore next */
    Object.keys(props).forEach((k) => {
        if (k !== snakeCase(k)) {
            throw new Error(`${k} must be a snake_case property (${snakeCase(k)})`);
        }
        const val = props[k];
        if (val !== undefined && val !== null) {
            properties[titleCase(k.replace(/[_]/g, " "))] =
                typeof val === "boolean"
                    ? val
                        ? "Yes"
                        : "No"
                    : String(val).replace(/\s+/g, " ").trim();
        }
    });
    return properties;
};
//# sourceMappingURL=buildHeapProperties.js.map